exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-b6a9360e] .upload-demo .el-upload {\n  width: 100%;\n}\n[data-v-b6a9360e] .upload-demo .upload-btn,[data-v-b6a9360e] .upload-demo .file-name {\n  width: 100%;\n  color: #275FE8;\n  font-size: 14px;\n  height: 32px;\n}\n[data-v-b6a9360e] .upload-demo .upload-btn ::v-deep .el-input__inner,[data-v-b6a9360e] .upload-demo .file-name ::v-deep .el-input__inner {\n  color: #275FE8;\n}\n[data-v-b6a9360e] .upload-demo .el-upload-list {\n  display: none;\n}\n[data-v-b6a9360e] .upload-demo .el-button {\n  width: 100%;\n  color: #275fe8;\n  font-size: 14px;\n}", ""]);

// exports
